module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "layout",
    attrs: {
      "id": "layout-full-width"
    }
  }, [_c('div', {
    attrs: {
      "id": "tooltip-container"
    }
  }), _vm._v(" "), _c('header', {
    attrs: {
      "id": "nav-container"
    }
  }, [_c('main-nav')], 1), _vm._v(" "), _c('main', {
    attrs: {
      "id": "content-container"
    }
  }, [_c('div', {
    class: {
      'is-open': _vm.chatRoomOpen
    },
    attrs: {
      "id": "chat-room-toggle"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toggleChatRoom($event)
      }
    }
  }, [_c('i', {
    staticClass: "far fa-comment-alt"
  })]), _vm._v(" "), _c('sub-nav'), _vm._v(" "), _c('article', {
    attrs: {
      "id": "content"
    }
  }, [_c('router-view'), _vm._v(" "), _c('layout-footer')], 1), _vm._v(" "), _c('chat-companion')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8428f21c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Layouts/LayoutFullWithChat.vue
// module id = 897
// module chunks = 2